module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Audition"
  }, [(_vm.daysLeftForRegistration >= 0) ? _c('div', [(!_vm.adminContext) ? _c('div', {
    staticClass: "end-of-time"
  }, [_c('label', {
    staticClass: "end-of-time-days"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.daysLeftForRegistration) + " יום\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("למועד סגירת ההרשמה, הבטיחו את מקומכם עכשיו!")])]) : _vm._e(), _vm._v(" "), (!_vm.adminContext) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.audition_text1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.site === null) ? _c('div', {
    staticClass: "auditionSiteMessage"
  }, [_c('label', {
    staticClass: "auditionDateLabel"
  }, [_c('b', [_vm._v(_vm._s(_vm.auditionCurrentDate))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auditionTab",
    class: {
      auditionTabActive: _vm.site === 'north'
    },
    on: {
      "click": function($event) {
        return _vm.chooseNorth()
      }
    }
  }, [_vm._v("צפון (חיפה)")]), _c('div', {
    staticClass: "auditionTab",
    class: {
      auditionTabActive: _vm.site === 'center'
    },
    on: {
      "click": function($event) {
        return _vm.chooseCenter()
      }
    }
  }, [_vm._v("מרכז (תל אביב)")]), _vm._v(" "), _c('div', {
    staticClass: "auditionBlock"
  }, [(_vm.auditionsDays[0].day != '') ? _c('div', {
    staticClass: "auditionDate"
  }, [_c('div', {
    staticClass: "auditionNextDate",
    class: {
      buttonHidden: _vm.pickedDay > _vm.auditionsDays.length - 2
    },
    on: {
      "click": function($event) {
        return _vm.nextDay()
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "הבא",
      "src": "images/arrow-next.png"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "auditionDateLabel"
  }, [_vm._v(_vm._s(_vm.auditionCurrentDate))]), _vm._v(" "), _c('div', {
    staticClass: "auditionPrevDate",
    class: {
      buttonHidden: _vm.pickedDay <= 0
    },
    on: {
      "click": function($event) {
        return _vm.prevDay()
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "הקודם",
      "src": "images/arrow-prev.png"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auditionSlots"
  }, [(_vm.site == null) ? _c('div', {
    staticClass: "fullAuditionMessage"
  }, [_c('mark', {
    staticClass: "auditionSlotLabel"
  }, [_vm._v("מועדי האודישנים הפנויים יוצגו לאחר בחירת הסניף")])]) : _vm._e(), _vm._v(" "), (_vm.site != null && _vm.auditionsDays[0].day === '') ? _c('div', {
    staticClass: "fullAuditionMessage"
  }, [_c('br'), _vm._v(" "), _c('mark', {
    staticClass: "auditionSlotLabel"
  }, [_vm._v("אין מועדים פנויים לאודישן")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.auditionsDays[_vm.pickedDay].data), function(audition) {
    return _c('div', {
      staticClass: "auditionSlot",
      class: {
        auditionPicked: _vm.pickedTimeSlot === audition,
        auditionTaken: !audition.open
      },
      on: {
        "click": function($event) {
          return _vm.pickaudition(audition)
        }
      }
    }, [_c('label', {
      staticClass: "auditionSlotLabel"
    }, [_vm._v(_vm._s(audition.hour))])])
  }), _vm._v(" "), (_vm.site != null && _vm.auditionsDaysComplete[_vm.pickedDay]) ? _c('div', {
    staticClass: "fullAuditionMessage"
  }, [_c('mark', {
    staticClass: "auditionSlotLabel"
  }, [_vm._v("יום אודישנים מלא!")]), _c('br'), _vm._v(" "), _c('mark', {
    staticClass: "auditionSlotLabel"
  }, [_vm._v("לחצו על החץ כדי לעבור למועד הבא")])]) : _vm._e()], 2), _vm._v(" "), _c('label', {
    staticClass: "audition-next-button",
    class: {
      nextButtonDisabled: Object.keys(_vm.pickedTimeSlot).length === 0 && _vm.pickedTimeSlot.constructor === Object
    },
    on: {
      "click": function($event) {
        return _vm.moveToLogin()
      }
    }
  }, [_vm._v("\n\t\t\t\tהבא\n\t\t\t")])]), _vm._v(" "), (!_vm.adminContext) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.audition_text2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLogin) ? _c('Login', {
    attrs: {
      "userId": _vm.userId,
      "adminContext": _vm.adminContext,
      "pickedTimeSlot": _vm.pickedTimeSlot,
      "auditionType": _vm.auditionType,
      "branchInput": _vm.site
    },
    on: {
      "close": function($event) {
        _vm.showLogin = false
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "Audition"
  }, [(!_vm.adminContext) ? _c('div', [_c('div', {
    staticClass: "end-of-time"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.audition_text3)
    }
  })]), _vm._v(" "), _c('TalkToMeNoModal', {
    attrs: {
      "auditionType": _vm.auditionType
    }
  })], 1) : _c('div', [_vm._v("\n\t\t\tאין מועדים פנויים לאודישן\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d00adad0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audition.vue
// module id = 124
// module chunks = 0